import {http} from './config/config-relation-register'

export default{
    listar:(token)=>{
        return  http.get('tipos-formulacao',{
            headers:{
                'Authorization':token
            }
        })
    },
    salvar:(token, item)=>{
        return http.post('tipos-formulacao',item,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idItem)=>{
        return http.delete('tipos-formulacao/'+idItem,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, item)=>{
        return http.put('tipos-formulacao/'+item.id_tipo_formulacao,item,{
            headers:{
                'Authorization':token
            }
        })
    }

}